import uuidV4 from 'uuid/v4';
import { getAccessTokenFromState } from 'utils/userManager';

export const getCommonHeaders = store => {
  const state = store.getState();
  const accessToken = getAccessTokenFromState(state);
  return {
    ...wowCustomHeader(state),
    'Content-Type': 'application/json',
    authorization: `Bearer ${accessToken}`
  };
};

export const wowCustomHeader = store => {
  const techEmail = store.getIn(['user', 'userId']);
  const getTechs = store.getIn(['techData', 'techs']);
  const techId = getTechs && getTechs.getIn([techEmail, 'info', 'techId']);
  const requestId = uuidV4();
  const currentWorkDay = new Date().toISOString();
  const sessionId = userSessionId(store);

  return {
    'wow-tech-id': techId,
    'wow-tech-email': techEmail,
    'wow-request-id': requestId,
    'wow-session-id': sessionId,
    'wow-current-work-day': currentWorkDay
  };
};


const userSessionId = store => {
  const hasToken = getAccessTokenFromState(store);
  if (hasToken) {
    return generateCookieIfDoesntExist('wow-session-id');
  }
};


const getCookieValue = key => {
  const allCookiesValues = document.cookie
    .split(';')
    .map(cookie => cookie.split('='))
    .reduce((accumulator, [key, value]) => ({ ...accumulator, [key.trim()]: decodeURIComponent(value) }), {});
  return allCookiesValues[key];
};

const generateCookieIfDoesntExist = key => {
  const hasCookie = getCookieValue(key);
  if (!hasCookie) {
    document.cookie = `wow-session-id=${uuidV4()}`;
    return getCookieValue('wow-session-id');
  } else {
    return getCookieValue('wow-session-id');
  }
};



// WEBPACK FOOTER //
// ./src/utils/wowCustomHeadersUtils.js